import React from "react";
import { Box, Typography } from "@material-ui/core";

import { useAppSelector } from "store";
import { selectComparatorsByChapter } from "modules/customer/tools/location/locationSlice";
import { selectIsLoading, selectHasErrors, selectStoreCounts } from "modules/customer/tools/location/retailers/retailersSlice";


import useColourPalette from "components/visuals/useColourPalette";
import KPIComparison from "components/visuals/KPIComparison";

import numberFormatter from "utils/numberFormatter";

const NumberOfStores = () => {
    const colourPalette = useColourPalette();
    const selectedComparator = useAppSelector(selectComparatorsByChapter)?.retailers;
    const isLoading = useAppSelector(selectIsLoading);
    const hasErrors = useAppSelector(selectHasErrors);
    const numberOfStores = useAppSelector(selectStoreCounts).numberOfStores;
    const selectedStoreNumberOfStores = numberOfStores?.pinnedLocationValue ?? 0;
    const comparatorNumberOfStores = numberOfStores?.comparisonValue ?? 0;
    const difference = numberOfStores?.difference ?? 0;
    const differencePositiveSign = difference > 0 ? "+" : "";

    const label = `Number of stores within the selected location`;

    return (
        <Box width="100%" height="100%" data-cy="number-of-stores-in-retail-zone">
            <KPIComparison
                isLoading={isLoading}
                hasErrors={hasErrors}
                targetValue={
                    <Typography variant="h3" component="div" style={{ color: colourPalette.comparators[0] }}>
                        {selectedStoreNumberOfStores}
                    </Typography>
                }
                targetLabel={label}
                comparisonValue={
                    <Typography variant="h6" component="div" style={{ color: colourPalette.comparators[1] }}>
                        {comparatorNumberOfStores}
                    </Typography>
                }
                comparisonLabel={`Comparator: ${selectedComparator?.storeName} `}
                differenceValue={
                    <Typography variant="h6" component="div" style={{ color: "#FFFFFF" }}>
                        {differencePositiveSign}{numberFormatter.toPercentage(difference, true, 2)}
                    </Typography>
                }
                differenceLabel="Difference"
            />
        </Box>
    );
};

export default NumberOfStores;
